export default "__VITE_ASSET__ItTD9o2z__"